// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMAuthPopup-module__font-s-10___hL1e_ {
  font-size: 10px !important;
}

.CGMAuthPopup-module__font-s-12___F9Ok5 {
  font-size: 12px !important;
}

.CGMAuthPopup-module__font-s-13___oEXUF {
  font-size: 13px !important;
}

.CGMAuthPopup-module__font-s-14___lDA28 {
  font-size: 14px !important;
}

.CGMAuthPopup-module__font-s-15___wvl5E {
  font-size: 15px !important;
}

.CGMAuthPopup-module__font-s-16___ml4Mg {
  font-size: 16px !important;
}

.CGMAuthPopup-module__font-s-18___zbyPc {
  font-size: 18px !important;
}

.CGMAuthPopup-module__font-s-20___rDJ6d {
  font-size: 20px !important;
}

.CGMAuthPopup-module__font-s-22___cRE_J {
  font-size: 22px !important;
}

.CGMAuthPopup-module__font-s-28___SGxE3 {
  font-size: 28px !important;
}

.CGMAuthPopup-module__font-w-400___vu4K7 {
  font-weight: 400 !important;
}

.CGMAuthPopup-module__font-w-500___M0s4m {
  font-weight: 500 !important;
}

.CGMAuthPopup-module__font-w-600___P0zWh {
  font-weight: 600 !important;
}

.CGMAuthPopup-module__font-w-700___AJCkc {
  font-weight: 700 !important;
}

.CGMAuthPopup-module__p-5___YpAHi {
  padding: 5px !important;
}

.CGMAuthPopup-module__p-12___xUNN9 {
  padding: 12px !important;
}

.CGMAuthPopup-module__p-16_____xJi {
  padding: 16px !important;
}

.CGMAuthPopup-module__p-30___Duffj {
  padding: 30px !important;
}

.CGMAuthPopup-module__p-b-0___X6o25 {
  padding-bottom: 0 !important;
}

.CGMAuthPopup-module__p-b-5___x5ne1 {
  padding-bottom: 5px !important;
}

.CGMAuthPopup-module__p-b-10___H3ZcN {
  padding-bottom: 10px !important;
}

.CGMAuthPopup-module__p-b-12___zikUF {
  padding-bottom: 12px !important;
}

.CGMAuthPopup-module__p-b-16___ekn4M {
  padding-bottom: 16px !important;
}

.CGMAuthPopup-module__p-b-18___f057C {
  padding-bottom: 18px !important;
}

.CGMAuthPopup-module__p-b-20___KeRo7 {
  padding-bottom: 20px !important;
}

.CGMAuthPopup-module__p-b-25___FPHkn {
  padding-bottom: 25px !important;
}

.CGMAuthPopup-module__p-b-30___cdO62 {
  padding-bottom: 30px !important;
}

.CGMAuthPopup-module__p-b-50___zjkwH {
  padding-bottom: 50px !important;
}

.CGMAuthPopup-module__p-t-0___rW3D5 {
  padding-top: 0 !important;
}

.CGMAuthPopup-module__p-t-12___XdFgh {
  padding-top: 12px !important;
}

.CGMAuthPopup-module__p-t-16___OXJYo {
  padding-top: 16px !important;
}

.CGMAuthPopup-module__p-t-18___rCG3f {
  padding-top: 18px !important;
}

.CGMAuthPopup-module__p-t-20___kdZaN {
  padding-top: 20px !important;
}

.CGMAuthPopup-module__p-t-30___AAmPl {
  padding-top: 30px !important;
}

.CGMAuthPopup-module__p-t-40___UGks9 {
  padding-top: 40px !important;
}

.CGMAuthPopup-module__p-t-50___KNnqw {
  padding-top: 50px !important;
}

.CGMAuthPopup-module__p-l-20___iSeNV {
  padding-left: 20px !important;
}

.CGMAuthPopup-module__p-l-30___Nw3AL {
  padding-left: 30px !important;
}

.CGMAuthPopup-module__p-l-40___KetJu {
  padding-left: 40px !important;
}

.CGMAuthPopup-module__p-r-16___b7xSX {
  padding-right: 16px !important;
}

.CGMAuthPopup-module__p-r-20___EUmKO {
  padding-right: 20px !important;
}

.CGMAuthPopup-module__p-r-30___r_9g0 {
  padding-right: 30px !important;
}

.CGMAuthPopup-module__p-r-50___N81FN {
  padding-right: 50px !important;
}

.CGMAuthPopup-module__p-r-60___DS6tC {
  padding-right: 60px !important;
}

.CGMAuthPopup-module__m-b-1___glo1T {
  margin-bottom: 1px !important;
}

.CGMAuthPopup-module__m-b-2___uc3hr {
  margin-bottom: 2px !important;
}

.CGMAuthPopup-module__m-b-6___t9Rix {
  margin-bottom: 6px !important;
}

.CGMAuthPopup-module__m-b-8___D9Yh4 {
  margin-bottom: 8px !important;
}

.CGMAuthPopup-module__m-b-10___sMS0m {
  margin-bottom: 10px !important;
}

.CGMAuthPopup-module__m-b-14___qGkug {
  margin-bottom: 14px !important;
}

.CGMAuthPopup-module__m-b-16___cSirL {
  margin-bottom: 16px !important;
}

.CGMAuthPopup-module__m-b-20___fAXtZ {
  margin-bottom: 20px !important;
}

.CGMAuthPopup-module__m-b-22___PtJKH {
  margin-bottom: 22px !important;
}

.CGMAuthPopup-module__m-b-24___o6g0Y {
  margin-bottom: 24px !important;
}

.CGMAuthPopup-module__m-b-30___AZPkF {
  margin-bottom: 30px !important;
}

.CGMAuthPopup-module__m-b-32___nZuHF {
  margin-bottom: 32px !important;
}

.CGMAuthPopup-module__m-b-40___IGZTO {
  margin-bottom: 40px !important;
}

.CGMAuthPopup-module__m-t-2___xlasC {
  margin-top: 2px !important;
}

.CGMAuthPopup-module__m-t-3___N6yYd {
  margin-top: 3px !important;
}

.CGMAuthPopup-module__m-t-4___mnFWP {
  margin-top: 4px !important;
}

.CGMAuthPopup-module__m-t-5___gR39N {
  margin-top: 5px !important;
}

.CGMAuthPopup-module__m-t-8___PlBeh {
  margin-top: 8px !important;
}

.CGMAuthPopup-module__m-t-10___N6hGs {
  margin-top: 10px !important;
}

.CGMAuthPopup-module__m-t-15___bT4wN {
  margin-top: 15px !important;
}

.CGMAuthPopup-module__m-t-16___X45rx {
  margin-top: 16px !important;
}

.CGMAuthPopup-module__m-t-20___lXNZh {
  margin-top: 20px !important;
}

.CGMAuthPopup-module__m-t-22___PO_yl {
  margin-top: 22px !important;
}

.CGMAuthPopup-module__m-t-30___Uxkwa {
  margin-top: 30px !important;
}

.CGMAuthPopup-module__m-t-32___XX5YZ {
  margin-top: 32px !important;
}

.CGMAuthPopup-module__m-l-auto___pJe3A {
  margin-left: auto !important;
}

.CGMAuthPopup-module__m-l-4___VqLPQ {
  margin-left: 4px !important;
}

.CGMAuthPopup-module__m-l-5___sLnbE {
  margin-left: 5px !important;
}

.CGMAuthPopup-module__m-l-6___Oofpj {
  margin-left: 6px !important;
}

.CGMAuthPopup-module__m-l-8___FN1FV {
  margin-left: 8px !important;
}

.CGMAuthPopup-module__m-l-10___C8PxD {
  margin-left: 10px !important;
}

.CGMAuthPopup-module__m-l-16___UYw8O {
  margin-left: 16px !important;
}

.CGMAuthPopup-module__m-l-20___cBohG {
  margin-left: 20px !important;
}

.CGMAuthPopup-module__m-l-24___GYOGT {
  margin-left: 24px !important;
}

.CGMAuthPopup-module__m-l-30___RYO5q {
  margin-left: 30px !important;
}

.CGMAuthPopup-module__m-l-35___vmrM6 {
  margin-left: 35px !important;
}

.CGMAuthPopup-module__m-l-40___MtNtY {
  margin-left: 40px !important;
}

.CGMAuthPopup-module__m-r-8___dsB6g {
  margin-right: 8px !important;
}

.CGMAuthPopup-module__m-r-10___ZuiHN {
  margin-right: 10px !important;
}

.CGMAuthPopup-module__m-r-16___Lz59i {
  margin-right: 16px !important;
}

.CGMAuthPopup-module__m-r-20___YQVub {
  margin-right: 20px !important;
}

.CGMAuthPopup-module__m-r-24___ylnsD {
  margin-right: 24px !important;
}

.CGMAuthPopup-module__m-r-30___ef68q {
  margin-right: 30px !important;
}

.CGMAuthPopup-module__m-r-40___gA1_c {
  margin-right: 40px !important;
}

.CGMAuthPopup-module__border-r-3___LQHlp {
  border-radius: 3px !important;
}

.CGMAuthPopup-module__border-r-4___vWtoy {
  border-radius: 4px !important;
}

.CGMAuthPopup-module__border-r-6___cdTHD {
  border-radius: 6px !important;
}

.CGMAuthPopup-module__border-r-10___tuVeE {
  border-radius: 10px !important;
}

.CGMAuthPopup-module__border-r-12___SSA3z {
  border-radius: 12px !important;
}

.CGMAuthPopup-module__border-r-16___iA8di {
  border-radius: 16px !important;
}

.CGMAuthPopup-module__border-r-50___Ccogv {
  border-radius: 50% !important;
}

.CGMAuthPopup-module__primary-border___QgH99 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAuthPopup-module__primary-border-b___oXvJo {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAuthPopup-module__primary-border-t___MeLKM {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAuthPopup-module__primary-border-l___wOxzF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAuthPopup-module__primary-border-r___Pomoz {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMAuthPopup-module__secondary-border___F94hK {
  border: 1px solid #637768;
}

.CGMAuthPopup-module__secondary-border-b___Ja8Vs {
  border-bottom: 1px solid #637768;
}

.CGMAuthPopup-module__secondary-border-t___dQvL9 {
  border-top: 1px solid #637768;
}

.CGMAuthPopup-module__secondary-border-l___VnfMP {
  border-left: 1px solid #637768;
}

.CGMAuthPopup-module__secondary-border-r___ahhfF {
  border-right: 1px solid #637768;
}

.CGMAuthPopup-module__gap-0___m6CMa {
  gap: 0 !important;
}

.CGMAuthPopup-module__gap-2___kCQsw {
  gap: 2px !important;
}

.CGMAuthPopup-module__gap-4___HIvOG {
  gap: 4px !important;
}

.CGMAuthPopup-module__gap-5___ZQRQU {
  gap: 5px !important;
}

.CGMAuthPopup-module__gap-6___mY71N {
  gap: 6px !important;
}

.CGMAuthPopup-module__gap-8___G3c7F {
  gap: 8px !important;
}

.CGMAuthPopup-module__gap-10___oCM8j {
  gap: 10px !important;
}

.CGMAuthPopup-module__gap-12___jauJh {
  gap: 12px !important;
}

.CGMAuthPopup-module__gap-14___knw2A {
  gap: 14px !important;
}

.CGMAuthPopup-module__gap-16___vQiZE {
  gap: 16px !important;
}

.CGMAuthPopup-module__gap-18___qTnPE {
  gap: 18px !important;
}

.CGMAuthPopup-module__gap-20___bv9j7 {
  gap: 20px !important;
}

.CGMAuthPopup-module__gap-24___mZ5af {
  gap: 24px !important;
}

.CGMAuthPopup-module__gap-26___WdM_L {
  gap: 26px !important;
}

.CGMAuthPopup-module__gap-30___F6lqf {
  gap: 30px !important;
}

.CGMAuthPopup-module__gap-32___SK7gy {
  gap: 32px !important;
}

.CGMAuthPopup-module__gap-40___tgrX4 {
  gap: 40px !important;
}

.CGMAuthPopup-module__gap-50___m9tUh {
  gap: 50px !important;
}

.CGMAuthPopup-module__flex-1___No_FP {
  flex: 1;
}

.CGMAuthPopup-module__flex-none___v4dth {
  flex: none !important;
}

.CGMAuthPopup-module__flex-column___dxVKT {
  display: flex;
  flex-direction: column !important;
}

.CGMAuthPopup-module__flex-row___Q98c5 {
  display: flex;
  flex-direction: row !important;
}

.CGMAuthPopup-module__vertically-centered___Y1Dh0 {
  display: flex;
  align-items: center !important;
}

.CGMAuthPopup-module__horizontally-centered___ct0fU {
  display: flex;
  justify-content: center !important;
}

.CGMAuthPopup-module__horizontally-end___OlO03 {
  display: flex;
  justify-content: end !important;
}

.CGMAuthPopup-module__vertically-start___xTQZE {
  display: flex;
  align-items: start !important;
}

.CGMAuthPopup-module__space-between___EmVOq {
  display: flex;
  justify-content: space-between !important;
}

.CGMAuthPopup-module__flex-wrap___Prb7K {
  flex-wrap: wrap !important;
}

.CGMAuthPopup-module__height-100___px7pT {
  height: 100%;
}

.CGMAuthPopup-module__width-50___HwDkM {
  width: 50% !important;
}

.CGMAuthPopup-module__width-100___wPQT9 {
  width: 100%;
}

.CGMAuthPopup-module__cursor-pointer___o_IZs {
  cursor: pointer;
}

.CGMAuthPopup-module__cursor-not-allowed___Tv0ve {
  cursor: not-allowed !important;
}

.CGMAuthPopup-module__absolute-centered___nBi0T {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMAuthPopup-module__absolute___hAd98 {
  position: absolute;
}

.CGMAuthPopup-module__relative___gB_em {
  position: relative;
}

.CGMAuthPopup-module__fixed___e1cAu {
  position: fixed;
}

.CGMAuthPopup-module__visible___gBiPI {
  opacity: 1;
}

.CGMAuthPopup-module__invisible___Jz2Cb {
  opacity: 0;
}

.CGMAuthPopup-module__col-90___VIK17 {
  width: 90% !important;
}

.CGMAuthPopup-module__col-auto___OORxW {
  width: auto !important;
}

.CGMAuthPopup-module__medical-tabs___JF3Ny {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMAuthPopup-module__medical-table-new___oluVO {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMAuthPopup-module__medical-table-new___oluVO:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMAuthPopup-module__medical-table-new___oluVO::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMAuthPopup-module__medical-table-new___oluVO::-webkit-scrollbar-track {
  display: none;
}
.CGMAuthPopup-module__medical-table-new___oluVO.CGMAuthPopup-module__no-pagination___B4TEG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMAuthPopup-module__medical-table-new___oluVO.CGMAuthPopup-module__no-pagination___B4TEG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMAuthPopup-module__medical-table-new___oluVO.CGMAuthPopup-module__no-pagination___B4TEG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMAuthPopup-module__medical-table-new___oluVO.CGMAuthPopup-module__no-pagination___B4TEG::-webkit-scrollbar-track {
  display: none;
}

.CGMAuthPopup-module__medical-table-empty___gSKxp {
  padding: 14px 40px !important;
}

.CGMAuthPopup-module__icon-btn___G_O16 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMAuthPopup-module__search-icon___A6NSM {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMAuthPopup-module__disable-select___fZ6Sn {
  user-select: none;
}

.CGMAuthPopup-module__break-word___Mul4a {
  word-break: break-word;
}

.CGMAuthPopup-module__popup-clear-btn___BJbkl {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMAuthPopup-module__scroll-m-b-20___dUkIZ {
  scroll-margin-bottom: 20px;
}

.CGMAuthPopup-module__manufacturerRow___fsBSn {
  display: flex;
  height: 70px;
  color: #375844;
}
.CGMAuthPopup-module__manufacturerRow___fsBSn .CGMAuthPopup-module__text___bMHbA {
  display: flex;
  flex: 1;
  line-height: 150%;
}
.CGMAuthPopup-module__manufacturerRow___fsBSn .CGMAuthPopup-module__select___JKYlm {
  width: 205px;
}

.CGMAuthPopup-module__authContainer___wmoG_ {
  min-height: 130px;
}
.CGMAuthPopup-module__authContainer___wmoG_ .CGMAuthPopup-module__title___ZRGNJ {
  line-height: 150%;
  color: #637768;
}
.CGMAuthPopup-module__authContainer___wmoG_ .CGMAuthPopup-module__textContainer___Lmp43 {
  min-height: 35px;
  border: 1px solid #859989;
  padding: 10px;
}
.CGMAuthPopup-module__authContainer___wmoG_ .CGMAuthPopup-module__textContainer___Lmp43 .CGMAuthPopup-module__content___HrGBu {
  line-height: 150%;
  color: #375844;
  word-wrap: break-word;
}

.CGMAuthPopup-module__authButton___WOgpE {
  line-height: 150%;
  color: #375844;
  cursor: pointer;
}

.CGMAuthPopup-module__statusInfo___NIfBv {
  display: flex;
  gap: 134px;
}
.CGMAuthPopup-module__statusInfo___NIfBv .CGMAuthPopup-module__title___ZRGNJ {
  line-height: 150%;
  color: #859989;
}
.CGMAuthPopup-module__statusInfo___NIfBv .CGMAuthPopup-module__content___HrGBu {
  line-height: 150%;
  color: #375844;
}

.CGMAuthPopup-module__buttonsContainer___iXx7j {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 19px 30px;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}
.CGMAuthPopup-module__buttonsContainer___iXx7j .CGMAuthPopup-module__button____orto {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/CGMAuthPopup/CGMAuthPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,OAAA;EACA,iBAAA;AA8pBJ;AA3pBE;EACE,YAAA;AA6pBJ;;AAzpBA;EACE,iBAAA;AA4pBF;AA1pBE;EACE,iBAAA;EACA,cAAA;AA4pBJ;AAzpBE;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;AA2pBJ;AAzpBI;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AA2pBN;;AAtpBA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAypBF;;AAtpBA;EACE,aAAA;EACA,UAAA;AAypBF;AAvpBE;EACE,iBAAA;EACA,cAAA;AAypBJ;AAtpBE;EACE,iBAAA;EACA,cAAA;AAwpBJ;;AAppBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,2CAAA;AAupBF;AArpBE;EACE,aAAA;AAupBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.manufacturerRow {\n  display: flex;\n  height: 70px;\n  color: get-color(greenNew, dark);\n\n  .text {\n    display: flex;\n    flex: 1;\n    line-height: 150%;\n  }\n\n  .select {\n    width: 205px;\n  }\n}\n\n.authContainer {\n  min-height: 130px;\n\n  .title {\n    line-height: 150%;\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .textContainer {\n    min-height: 35px;\n    border: 1px solid get-color(greenNew, medium);\n    padding: 10px;\n\n    .content {\n      line-height: 150%;\n      color: get-color(greenNew, dark);\n      word-wrap: break-word;\n    }\n  }\n}\n\n.authButton {\n  line-height: 150%;\n  color: get-color(greenNew, dark);\n  cursor: pointer;\n}\n\n.statusInfo {\n  display: flex;\n  gap: 134px;\n\n  .title {\n    line-height: 150%;\n    color: get-color(greenNew, medium);\n  }\n\n  .content {\n    line-height: 150%;\n    color: get-color(greenNew, dark);\n  }\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  padding: 19px 30px;\n  gap: 16px;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n\n  .button {\n    display: flex;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMAuthPopup-module__font-s-10___hL1e_`,
	"fontS12": `CGMAuthPopup-module__font-s-12___F9Ok5`,
	"fontS13": `CGMAuthPopup-module__font-s-13___oEXUF`,
	"fontS14": `CGMAuthPopup-module__font-s-14___lDA28`,
	"fontS15": `CGMAuthPopup-module__font-s-15___wvl5E`,
	"fontS16": `CGMAuthPopup-module__font-s-16___ml4Mg`,
	"fontS18": `CGMAuthPopup-module__font-s-18___zbyPc`,
	"fontS20": `CGMAuthPopup-module__font-s-20___rDJ6d`,
	"fontS22": `CGMAuthPopup-module__font-s-22___cRE_J`,
	"fontS28": `CGMAuthPopup-module__font-s-28___SGxE3`,
	"fontW400": `CGMAuthPopup-module__font-w-400___vu4K7`,
	"fontW500": `CGMAuthPopup-module__font-w-500___M0s4m`,
	"fontW600": `CGMAuthPopup-module__font-w-600___P0zWh`,
	"fontW700": `CGMAuthPopup-module__font-w-700___AJCkc`,
	"p5": `CGMAuthPopup-module__p-5___YpAHi`,
	"p12": `CGMAuthPopup-module__p-12___xUNN9`,
	"p16": `CGMAuthPopup-module__p-16_____xJi`,
	"p30": `CGMAuthPopup-module__p-30___Duffj`,
	"pB0": `CGMAuthPopup-module__p-b-0___X6o25`,
	"pB5": `CGMAuthPopup-module__p-b-5___x5ne1`,
	"pB10": `CGMAuthPopup-module__p-b-10___H3ZcN`,
	"pB12": `CGMAuthPopup-module__p-b-12___zikUF`,
	"pB16": `CGMAuthPopup-module__p-b-16___ekn4M`,
	"pB18": `CGMAuthPopup-module__p-b-18___f057C`,
	"pB20": `CGMAuthPopup-module__p-b-20___KeRo7`,
	"pB25": `CGMAuthPopup-module__p-b-25___FPHkn`,
	"pB30": `CGMAuthPopup-module__p-b-30___cdO62`,
	"pB50": `CGMAuthPopup-module__p-b-50___zjkwH`,
	"pT0": `CGMAuthPopup-module__p-t-0___rW3D5`,
	"pT12": `CGMAuthPopup-module__p-t-12___XdFgh`,
	"pT16": `CGMAuthPopup-module__p-t-16___OXJYo`,
	"pT18": `CGMAuthPopup-module__p-t-18___rCG3f`,
	"pT20": `CGMAuthPopup-module__p-t-20___kdZaN`,
	"pT30": `CGMAuthPopup-module__p-t-30___AAmPl`,
	"pT40": `CGMAuthPopup-module__p-t-40___UGks9`,
	"pT50": `CGMAuthPopup-module__p-t-50___KNnqw`,
	"pL20": `CGMAuthPopup-module__p-l-20___iSeNV`,
	"pL30": `CGMAuthPopup-module__p-l-30___Nw3AL`,
	"pL40": `CGMAuthPopup-module__p-l-40___KetJu`,
	"pR16": `CGMAuthPopup-module__p-r-16___b7xSX`,
	"pR20": `CGMAuthPopup-module__p-r-20___EUmKO`,
	"pR30": `CGMAuthPopup-module__p-r-30___r_9g0`,
	"pR50": `CGMAuthPopup-module__p-r-50___N81FN`,
	"pR60": `CGMAuthPopup-module__p-r-60___DS6tC`,
	"mB1": `CGMAuthPopup-module__m-b-1___glo1T`,
	"mB2": `CGMAuthPopup-module__m-b-2___uc3hr`,
	"mB6": `CGMAuthPopup-module__m-b-6___t9Rix`,
	"mB8": `CGMAuthPopup-module__m-b-8___D9Yh4`,
	"mB10": `CGMAuthPopup-module__m-b-10___sMS0m`,
	"mB14": `CGMAuthPopup-module__m-b-14___qGkug`,
	"mB16": `CGMAuthPopup-module__m-b-16___cSirL`,
	"mB20": `CGMAuthPopup-module__m-b-20___fAXtZ`,
	"mB22": `CGMAuthPopup-module__m-b-22___PtJKH`,
	"mB24": `CGMAuthPopup-module__m-b-24___o6g0Y`,
	"mB30": `CGMAuthPopup-module__m-b-30___AZPkF`,
	"mB32": `CGMAuthPopup-module__m-b-32___nZuHF`,
	"mB40": `CGMAuthPopup-module__m-b-40___IGZTO`,
	"mT2": `CGMAuthPopup-module__m-t-2___xlasC`,
	"mT3": `CGMAuthPopup-module__m-t-3___N6yYd`,
	"mT4": `CGMAuthPopup-module__m-t-4___mnFWP`,
	"mT5": `CGMAuthPopup-module__m-t-5___gR39N`,
	"mT8": `CGMAuthPopup-module__m-t-8___PlBeh`,
	"mT10": `CGMAuthPopup-module__m-t-10___N6hGs`,
	"mT15": `CGMAuthPopup-module__m-t-15___bT4wN`,
	"mT16": `CGMAuthPopup-module__m-t-16___X45rx`,
	"mT20": `CGMAuthPopup-module__m-t-20___lXNZh`,
	"mT22": `CGMAuthPopup-module__m-t-22___PO_yl`,
	"mT30": `CGMAuthPopup-module__m-t-30___Uxkwa`,
	"mT32": `CGMAuthPopup-module__m-t-32___XX5YZ`,
	"mLAuto": `CGMAuthPopup-module__m-l-auto___pJe3A`,
	"mL4": `CGMAuthPopup-module__m-l-4___VqLPQ`,
	"mL5": `CGMAuthPopup-module__m-l-5___sLnbE`,
	"mL6": `CGMAuthPopup-module__m-l-6___Oofpj`,
	"mL8": `CGMAuthPopup-module__m-l-8___FN1FV`,
	"mL10": `CGMAuthPopup-module__m-l-10___C8PxD`,
	"mL16": `CGMAuthPopup-module__m-l-16___UYw8O`,
	"mL20": `CGMAuthPopup-module__m-l-20___cBohG`,
	"mL24": `CGMAuthPopup-module__m-l-24___GYOGT`,
	"mL30": `CGMAuthPopup-module__m-l-30___RYO5q`,
	"mL35": `CGMAuthPopup-module__m-l-35___vmrM6`,
	"mL40": `CGMAuthPopup-module__m-l-40___MtNtY`,
	"mR8": `CGMAuthPopup-module__m-r-8___dsB6g`,
	"mR10": `CGMAuthPopup-module__m-r-10___ZuiHN`,
	"mR16": `CGMAuthPopup-module__m-r-16___Lz59i`,
	"mR20": `CGMAuthPopup-module__m-r-20___YQVub`,
	"mR24": `CGMAuthPopup-module__m-r-24___ylnsD`,
	"mR30": `CGMAuthPopup-module__m-r-30___ef68q`,
	"mR40": `CGMAuthPopup-module__m-r-40___gA1_c`,
	"borderR3": `CGMAuthPopup-module__border-r-3___LQHlp`,
	"borderR4": `CGMAuthPopup-module__border-r-4___vWtoy`,
	"borderR6": `CGMAuthPopup-module__border-r-6___cdTHD`,
	"borderR10": `CGMAuthPopup-module__border-r-10___tuVeE`,
	"borderR12": `CGMAuthPopup-module__border-r-12___SSA3z`,
	"borderR16": `CGMAuthPopup-module__border-r-16___iA8di`,
	"borderR50": `CGMAuthPopup-module__border-r-50___Ccogv`,
	"primaryBorder": `CGMAuthPopup-module__primary-border___QgH99`,
	"primaryBorderB": `CGMAuthPopup-module__primary-border-b___oXvJo`,
	"primaryBorderT": `CGMAuthPopup-module__primary-border-t___MeLKM`,
	"primaryBorderL": `CGMAuthPopup-module__primary-border-l___wOxzF`,
	"primaryBorderR": `CGMAuthPopup-module__primary-border-r___Pomoz`,
	"secondaryBorder": `CGMAuthPopup-module__secondary-border___F94hK`,
	"secondaryBorderB": `CGMAuthPopup-module__secondary-border-b___Ja8Vs`,
	"secondaryBorderT": `CGMAuthPopup-module__secondary-border-t___dQvL9`,
	"secondaryBorderL": `CGMAuthPopup-module__secondary-border-l___VnfMP`,
	"secondaryBorderR": `CGMAuthPopup-module__secondary-border-r___ahhfF`,
	"gap0": `CGMAuthPopup-module__gap-0___m6CMa`,
	"gap2": `CGMAuthPopup-module__gap-2___kCQsw`,
	"gap4": `CGMAuthPopup-module__gap-4___HIvOG`,
	"gap5": `CGMAuthPopup-module__gap-5___ZQRQU`,
	"gap6": `CGMAuthPopup-module__gap-6___mY71N`,
	"gap8": `CGMAuthPopup-module__gap-8___G3c7F`,
	"gap10": `CGMAuthPopup-module__gap-10___oCM8j`,
	"gap12": `CGMAuthPopup-module__gap-12___jauJh`,
	"gap14": `CGMAuthPopup-module__gap-14___knw2A`,
	"gap16": `CGMAuthPopup-module__gap-16___vQiZE`,
	"gap18": `CGMAuthPopup-module__gap-18___qTnPE`,
	"gap20": `CGMAuthPopup-module__gap-20___bv9j7`,
	"gap24": `CGMAuthPopup-module__gap-24___mZ5af`,
	"gap26": `CGMAuthPopup-module__gap-26___WdM_L`,
	"gap30": `CGMAuthPopup-module__gap-30___F6lqf`,
	"gap32": `CGMAuthPopup-module__gap-32___SK7gy`,
	"gap40": `CGMAuthPopup-module__gap-40___tgrX4`,
	"gap50": `CGMAuthPopup-module__gap-50___m9tUh`,
	"flex1": `CGMAuthPopup-module__flex-1___No_FP`,
	"flexNone": `CGMAuthPopup-module__flex-none___v4dth`,
	"flexColumn": `CGMAuthPopup-module__flex-column___dxVKT`,
	"flexRow": `CGMAuthPopup-module__flex-row___Q98c5`,
	"verticallyCentered": `CGMAuthPopup-module__vertically-centered___Y1Dh0`,
	"horizontallyCentered": `CGMAuthPopup-module__horizontally-centered___ct0fU`,
	"horizontallyEnd": `CGMAuthPopup-module__horizontally-end___OlO03`,
	"verticallyStart": `CGMAuthPopup-module__vertically-start___xTQZE`,
	"spaceBetween": `CGMAuthPopup-module__space-between___EmVOq`,
	"flexWrap": `CGMAuthPopup-module__flex-wrap___Prb7K`,
	"height100": `CGMAuthPopup-module__height-100___px7pT`,
	"width50": `CGMAuthPopup-module__width-50___HwDkM`,
	"width100": `CGMAuthPopup-module__width-100___wPQT9`,
	"cursorPointer": `CGMAuthPopup-module__cursor-pointer___o_IZs`,
	"cursorNotAllowed": `CGMAuthPopup-module__cursor-not-allowed___Tv0ve`,
	"absoluteCentered": `CGMAuthPopup-module__absolute-centered___nBi0T`,
	"absolute": `CGMAuthPopup-module__absolute___hAd98`,
	"relative": `CGMAuthPopup-module__relative___gB_em`,
	"fixed": `CGMAuthPopup-module__fixed___e1cAu`,
	"visible": `CGMAuthPopup-module__visible___gBiPI`,
	"invisible": `CGMAuthPopup-module__invisible___Jz2Cb`,
	"col90": `CGMAuthPopup-module__col-90___VIK17`,
	"colAuto": `CGMAuthPopup-module__col-auto___OORxW`,
	"medicalTabs": `CGMAuthPopup-module__medical-tabs___JF3Ny`,
	"medicalTableNew": `CGMAuthPopup-module__medical-table-new___oluVO`,
	"noPagination": `CGMAuthPopup-module__no-pagination___B4TEG`,
	"medicalTableEmpty": `CGMAuthPopup-module__medical-table-empty___gSKxp`,
	"iconBtn": `CGMAuthPopup-module__icon-btn___G_O16`,
	"searchIcon": `CGMAuthPopup-module__search-icon___A6NSM`,
	"disableSelect": `CGMAuthPopup-module__disable-select___fZ6Sn`,
	"breakWord": `CGMAuthPopup-module__break-word___Mul4a`,
	"popupClearBtn": `CGMAuthPopup-module__popup-clear-btn___BJbkl`,
	"scrollMB20": `CGMAuthPopup-module__scroll-m-b-20___dUkIZ`,
	"manufacturerRow": `CGMAuthPopup-module__manufacturerRow___fsBSn`,
	"text": `CGMAuthPopup-module__text___bMHbA`,
	"select": `CGMAuthPopup-module__select___JKYlm`,
	"authContainer": `CGMAuthPopup-module__authContainer___wmoG_`,
	"title": `CGMAuthPopup-module__title___ZRGNJ`,
	"textContainer": `CGMAuthPopup-module__textContainer___Lmp43`,
	"content": `CGMAuthPopup-module__content___HrGBu`,
	"authButton": `CGMAuthPopup-module__authButton___WOgpE`,
	"statusInfo": `CGMAuthPopup-module__statusInfo___NIfBv`,
	"buttonsContainer": `CGMAuthPopup-module__buttonsContainer___iXx7j`,
	"button": `CGMAuthPopup-module__button____orto`
};
module.exports = ___CSS_LOADER_EXPORT___;
